import React, { useEffect, useState } from "react";
import "../overview/styles/overview.scss";
import img from "../../assets/images/wallet_amount.png";
import { isEmpty } from "../../utils/common";
import { getTraveleBalance, getViewLiveBalance } from "../../utils/api";
import GloabalLoader from "../../Components/Loader/GloabalLoader";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function VenderBalance() {
  const [data, setData] = useState({});
  const [tboBalance, setTboBalance] = useState(null);
  const [tripjackBalance, setTripjackboBalance] = useState(null);
  const [loading,setLoading] = useState(false);


  const { user } = useSelector((state) => state.user);
  const navigationate = useNavigate();
  useEffect(() => {
    if (user?.userType !== "ROLE_ADMIN") {
        navigationate("/");
      return;
    
    }
    setLoading(true);

const body = {
  feedSource: 'TRIPJACK'
};
const bodyTbo = {
  feedSource: 'TBO'
};

Promise.all([getViewLiveBalance(), getTraveleBalance(body),getTraveleBalance(bodyTbo)])
  .then(([liveBalanceResp, travelBalanceResp,travelBalanceRespTbo]) => {
    if (liveBalanceResp.data?.success) {
      setData(liveBalanceResp?.data?.metaInfo);
    }
  
    if (travelBalanceRespTbo?.data?.status) {
      setTboBalance(travelBalanceRespTbo?.data?.data);
    }

    if (travelBalanceResp?.data?.status) {
      setTripjackboBalance(travelBalanceResp?.data?.data);
    }
  })
  .finally(() => {
    setLoading(false);
  });


  }, []);



  return (
    <div className="overview_container">
      {loading && <GloabalLoader></GloabalLoader>}
      <div className="overview_top_container">
        <div className="ov_head d-flex">
          <h1 className="page-title">Vendor Live Balance</h1>
        </div>

        <div className="content_wrapper">
          <div className="content_right">
            <div className="amount_overview">
              {!isEmpty(data?.doLiveBalance) && isEmpty(loading) &&(
                <AmountCard
                  img={img}
                  title="DIOSM Live Balance"
                  amount={<strong className="fs-18">₹{isEmpty(data?.doLiveBalance) ? "0.00" : data?.doLiveBalance}</strong> }
                />
              )}
             {isEmpty(loading) && <AmountCard
                img={img}
                title="Roundpay Live Balance"
                amount={<strong className="fs-18">₹{isEmpty(data?.rpLiveBalance) ? "0.00" :data?.rpLiveBalance}</strong> }
          
              />}
              {isEmpty(loading) &&(
                <AmountCard
                  img={img}
                  title="TBO  Balance"
                  amount={<div className="fs-18 titlcard flex" style={{gap:"5px"}}><span>credit: </span><strong>₹{tboBalance?.credit || 0}</strong></div>}
                  count={<div className="fs-18 titlcard flex" style={{gap:"5px"}}><span>Cash: </span><strong>₹{tboBalance?.cash || 0}</strong></div>}
                />
              )}
            
               
             {isEmpty(loading) && <AmountCard
                img={img}
                title="Tripjack  Balance"
         
                amount={<div className="fs-18 titlcard flex" style={{gap:"5px"}}><span>credit: </span><strong>₹{tripjackBalance?.credit || 0}</strong></div>}
                count={<div className="fs-18 titlcard flex" style={{gap:"5px"}}><span>Cash: </span><strong>₹{tripjackBalance?.cash || 0}</strong></div>}
              />} 
            </div>
          </div>
          {/* {user?.userType !== "ROLE_DISTRIBUTOR" && <div className="content_left">
                       <TotalMembers totalPayinPayout={totalPayinPayout}/>
                    </div>} */}
        </div>
      </div>
    </div>
  );
}

export default VenderBalance;

export const AmountCard = ({ img, title, amount=null, count = null }) => {
  return (
    <div className="amount_overview_pic_with_right_text">
      <div className="pic">
        <img src={img}></img>
      </div>
      <div className="text-info">
        <span>{title}</span>
        {!isEmpty(count) && count}
        {!isEmpty(amount) && amount}
      
      </div>
    </div>
  );
};
